module.exports = __webpack_public_path__ + "media/images/sample/oraganization_logo_1-1417806a794da1d1cf23dc62aabf1248.png";